import React, { useEffect, useState } from "react";
import { useCase } from "../../../provider/CaseProvider";
import ApiClient from "../../../services/ApiClient";
import { HydraCollectionResult } from "../../../types/HydraCollectionResult";
import Template from "../../../types/Template";
import { AutoCompleteOptionWithValue } from "../../../types/AutoCompleteOptionWithValue";
import LegalbirdAutoComplete from "../../AutoComplete/LegalbirdAutoComplete";
import { fillTemplate } from "../../../services/Template/templateService";
import { useCurrentEditor } from "@tiptap/react";
import { useFormContext } from "react-hook-form-mui";

type AddTextBlockProps = {
  context: Template["context"];
};

export default function AddTextBlock({ context }: AddTextBlockProps) {
  const [templates, setTemplates] = useState<Template[]>([]);

  const { product } = useCase();
  const { editor } = useCurrentEditor();
  const formContext = useFormContext();

  useEffect(() => {
    if (!product) {
      return;
    }

    ApiClient.get("templates").then((result: HydraCollectionResult<Template>) => {
      const filteredTemplates = result["hydra:member"].filter((template) => {
        return (
          template.type === "text" &&
          template.context.includes(context) &&
          [
            "general",
            product.productCategory === "contractLaw" && product.productClassName !== "dataLeakContract"
              ? "contractLaw"
              : product.productClassName,
          ].includes(template.productClassName)
        );
      });
      setTemplates(filteredTemplates);
    });
  }, [product?.id]);

  if (!product || !editor) {
    return null;
  }

  const addTextBlock = (templateContent: Template["content"]) => {
    if (!templateContent) {
      return;
    }

    editor.commands.insertContent(fillTemplate(templateContent, product, formContext?.getValues()));
  };

  const handlePlaceholderClick = (template: Template) => {
    addTextBlock(`${template.content}`);
  };

  return (
    <LegalbirdAutoComplete<AutoCompleteOptionWithValue>
      sx={{ minWidth: "9rem" }}
      slotProps={{
        popper: {
          style: { width: "fit-content" },
        },
      }}
      value={null}
      setValue={(event, option) => {
        const template = templates.find((t) => t.id === option?.value);
        if (template) {
          handlePlaceholderClick(template);
        }
      }}
      textFieldProps={{ variant: "standard", fullWidth: true, placeholder: "Text einfügen" }}
      textFieldStyles={{ margin: 0 }}
      options={[
        ...templates.map((template) => ({
          value: template.id,
          label: template.label,
        })),
      ]}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      label={""}
    />
  );
}
